import classNames from 'classnames';

import Checkbox, { type CheckboxProps } from '../checkbox/checkbox';

import styles from './labeled_checkbox.module.css';

type Props = CheckboxProps & {
  label: string;
  labelPlacement?: 'start' | 'end';
};

export function LabeledCheckbox(props: Props) {
  const { label, labelPlacement, ...rest } = props;
  return (
    <div>
      <label
        className={classNames(styles.root, {
          [styles.right_alignment]: labelPlacement === 'end',
        })}
      >
        <span className={styles.label}>{label}</span>
        <Checkbox {...rest} />
      </label>
    </div>
  );
}
